import { initEnquiry } from "../../utils/Enquiries"
import { regularPickerOptions } from "../../utils/DatePickerSupport"

const ENQUIRY_SELECTOR = "#js-general-enquiry"

export default () => {
  initEnquiry(document.querySelector(ENQUIRY_SELECTOR))

  $(`${ENQUIRY_SELECTOR} .js-arrival-date`)
    .pickadate(regularPickerOptions())
    .pickadate("picker")
}



// WEBPACK FOOTER //
// ./components/enquiries/general_enquiry.js